module.exports = __webpack_public_path__ + "static/media/nps_arrow.4d4eb320.svg";